import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { GET_CONSUMER_SCHEDULED_REGULAR_SERVICES } from "../../../../graphql/serviceRequests/getConsumerScheduledRegularServices";
import { IAppState } from "../../../../store";
import { UserRole } from "../../../../reducers/auth/types";

export function useConsumerScheduledServices() {
  const user = useSelector((state: IAppState) => state.authReducer.user);
  const businessCustomerId = user?.businesscustomers?.id || null;
  const customerId = businessCustomerId ? null : user?.customerId || null;
  const driverId = businessCustomerId && user?.role === UserRole.DRIVER ? user.id : null;

  const { data, loading, refetch } = useQuery(GET_CONSUMER_SCHEDULED_REGULAR_SERVICES, {
    fetchPolicy: "network-only",
    skip: !businessCustomerId && !customerId,
    variables: { businessCustomerId, customerId, driverId },
  });

  const services = data?.consumerScheduledRegularServices?.services ?? [];

  return {
    services,
    count: services.length,
    loading,
    refetch,
    hasConsumerContext: Boolean(businessCustomerId || customerId),
  };
}
